import { useContext } from "react";
import { KycFilesUIContext } from "../modules/kyc-v2/components/compliance/KycFilesUIContext";

export const useKycFilesUIContext = () => useContext(KycFilesUIContext);
